/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, warp-drive/no-legacy-request-patterns */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import PostType from '@linc-technologies/linced-common/enums/post-type';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: posts.FeedEntry.
export default class FeedEntry extends Model {
  declare [Type]: 'posts/feed-entry';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string;

  @attr('number', { defaultValue: 0 })
  declare type: EnumValue<typeof PostType> | 0;

  @attr('boolean', { defaultValue: false })
  declare isRead: boolean;

  @attr('string', { defaultValue: '' })
  declare entityId: string;

  @computed('type', 'entityId')
  get entity() {
    let model = 'post';
    switch (this.type) {
      case PostType.COMMUNITY_NOTICE:
        model = 'communitynotice';
        break;
      case PostType.STAFF_NOTICE:
        model = 'staffnotice';
        break;
      case PostType.ATTENDANCE_NOTE:
        model = 'attendancenote';
        break;
      case PostType.STUDENT_NOTICE:
        model = 'studentnotice';
        break;
      // TODO: Add Global Notices, when we implement/use them.
    }
    return this.store.peekRecord(`posts/${model}`, this.entityId);
  }
}
